<template>
  <div>
    <!--- Loader --->
    <v-overlay :color="'#fff'" :value="loading" z-index="10" opacity="1">
      <div class="overlay-content">
        <img src="@/assets/images/svg/logo.svg" alt="logo" />
        <v-progress-linear
          :value="progress"
          color="primary"
          background-color="element-bg-300"
          height="6"
          rounded></v-progress-linear>
      </div>
    </v-overlay>
    <!--- Loader END --->

    <iframe class="full-page-iframe" :src="iframeUrl" @load="toolsLoaded"></iframe>
  </div>
</template>

<script>
  export default {
    props: {
      id: {
        type: String,
        required: false,
      },
    },
    data() {
      return {
        loading: false,
        progress: 0,
        interval: null,
        iframeUrl: process.env.VUE_APP_AI_TOOLS_URL,
      };
    },
    beforeMount() {
      document.documentElement.style.overflowY = "hidden";
      this.displayLoader();
    },
    mounted() {
      window.addEventListener("message", this.handleMessage);
    },
    beforeDestroy() {
      document.documentElement.style.overflowY = "unset";
      window.removeEventListener("message", this.handleMessage);
    },
    methods: {
      handleError(e) {
        console.log("handleErr", e);
      },
      displayLoader() {
        this.loading = true;
        /**
         * Simulated, non-linear loading. Loads as long as possible, slowing down the further it gets.
         */
        this.interval = setInterval(() => {
          const increment = (100 - this.progress) / 10;
          if (this.progress < 95) {
            this.progress += increment;
          } else {
            this.progress += 0.05;
          }
          if (this.progress > 99.5) {
            this.progress = 99.5;
          }
        }, 250);
      },
      toolsLoaded() {
        this.progress = 100;
        clearInterval(this.interval);
        this.loading = false;
      },
      async handleMessage(e) {
        // TODO: any messages from within the iframe should be handled here
        console.log(e);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .overlay-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 320px;
    img {
      margin-bottom: 16px;
    }
  }

  .full-page-iframe {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    border: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    z-index: 999999;
  }
</style>
